import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import {Provider, connect} from "react-redux";

import {BookButton, BookButtonDiv} from "../../../spaceplanner/styles/Common/button";
import { ModalController } from "../../../../src/common/components/Modal";
import LabelIcon from "calcite-ui-icons-react/LabelIcon";

import Attributes from "./Attributes";
import Context from "../../../context/Context";
import InfoPanelHeader from "./InfoPanelHeader";
import Rdx from "../../../redux/Rdx";
import Related from "./Related";
import RealTimeLocation from "./RealTimeLocation";
import ShareDropdown from "./ShareDropdown";
import Topic from "../../../context/Topic";
import * as Actions from "./Actions";
import * as actionUtil from "./actionUtil";
import * as appLaunchUtil from "../../../aiim/util/appLaunchUtil";
import * as component from "../../util/component";
import * as itemUtil from "../../../aiim/util/itemUtil";
import * as shareUtil from "./shareUtil";
import { login, getAccessToken, getBookingSchedule, bookWorkspace, getLoggedInUser } from "../../../../src/components/main/More/Actions/BookWorkspace/WorkspaceReservation/OfficeHotelingInterface";
import FieldNames from "../../../../src/aiim/datasets/FieldNames";
import { stringFormatter } from "../../../../src/util/formatUtil";

import * as aiimUtil from "../../../../src/aiim/util/aiimUtil";
import * as reservationUtil from "../../../aiim/util/reservationUtil";
import BookingDetails from "../More/Actions/BookWorkspace/BookingDetails";
import BookingConfirmed from "../More/Actions/BookWorkspace/BookingConfirmed";
import * as bookWorkspaceUtil from "../More/Actions/BookWorkspace/BookWorkspaceUtil";
import { getAreaName, getBookingSystem, getBookingSystemType } from "../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil";
import { getAttributes } from "../../../spaceplanner/components/common/MultipleAssignments/multipleAssignmentsUtil";
import { getZulu } from "../Events/dateUtil";
import { escSqlQuote } from "../../../aiim/util/selectionUtil";
import MyHotelBookings from "./MyHotelBookings";
import { isNetworkError } from "../../../util/networkUtil";

const CSS = {
  main: "i-content",
  infopanelContent: "i-infopanel-content",
  featureContent: "i-infopanel-content-feature",
  actionBar: "i-actionbar",
  tabs: "tab-nav",
  tab: "tab-title",
  activeTab: "is-active",
  tabContent: "i-infopanel-feature-tabcontent",
  bookButton: "i-bookbutton",
  bookButtonDiv: "i-bookbuttondiv",
  actionBarContainer: "i-actionbar-container",
  infopanelBookButton: "i-infopanel-book-button"
};


class ItemDetails extends React.Component {

  constructor(props) {
    super(props);
    const item = this.props.item;
    this.bookingSystem = getBookingSystem();
    this.state = component.newState({
      activeTab: "attributes",
      appLaunchUrls: [],
      mode: "details",
      _311Url: null,
      shareUrl: shareUtil.generateShareUrl(item),
      spaceType : null,
      areaName : null,
      scheduleEmail : null,
      levelName: null,
      bookings: []
    });
    this.modeClicked = this.modeClicked.bind(this);
    this.tabClicked = this.tabClicked.bind(this);
  }


  bookClicked = (e,when) => {
    const item = this.props.item;
    const attributes = item.searchResult.feature.attributes;
    const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID);
    const spaceType = aiimUtil.getAttributeValue(attributes, FieldNames.UNITS_USE_TYPE);
    const unitName = aiimUtil.getAttributeValue(attributes, FieldNames.NAME);
    const scheduleEmail = aiimUtil.getAttributeValue(attributes, FieldNames.SCHEDULE_EMAIL);
    let levelName = aiimUtil.getAttributeValue(attributes, FieldNames.LEVEL_NAME)+"z";
    let facilityName = aiimUtil.getAttributeValue(attributes, FieldNames.FACILITY_NAME)+"z";
    const unitsDataset = Context.instance.aiim.datasets.units;
    if (unitsDataset) {
      const levelData = unitsDataset.getLevelData(item.searchResult.feature);
      if (levelData && levelData.levelName) levelName = levelData.levelName;
      if (levelData && levelData.facilityName) facilityName = levelData.facilityName;
    }
    const bookingSystem = this.bookingSystem;

    let user = getLoggedInUser(bookingSystem)
    if (user) {
      return getAccessToken(bookingSystem)
      .then(() => {
        return getAreaName(areaId);
      })
      .then((areaName)=> {
        this.setState({
          spaceType : spaceType,
          areaName : areaName,
          scheduleEmail : scheduleEmail,
          unitName : unitName,
          levelName : levelName,
          facilityName : facilityName
        }, ()=>{
          this.renderBookingDetails(when);
        })
      })
      .catch(error =>{
        console.log("Error in booking workspace.", error);
      })
    } else {
      return login(bookingSystem)
      .then((status)=>{
        if(status === "Success") return getAreaName(areaId);
      })
      .then((areaName)=> {
        this.setState({
          spaceType : spaceType,
          areaName : areaName,
          scheduleEmail : scheduleEmail,
          unitName : unitName,
          levelName : levelName,
          facilityName : facilityName
        }, ()=>{
          this.renderBookingDetails(when);
        })
      })
      .catch(error =>{
        console.log("Error in booking workspace.", error);
      })
    }
  }

  componentDidMount() {
    //this.generate311Url();
    this.generateAppLaunchUrls();
    this.queryUserReservations();
    component.own(this,[
      Topic.subscribe(Topic.AppLaunchURLsChanged,params => {
        this.generateAppLaunchUrls();
      }),
      Topic.subscribe(Topic.ReferenceLayerUpdated,params => {
        component.refresh(this);
      }),
      Topic.subscribe(Topic.Three11UrlChanged,params => {
        this.generate311Url();
      }),
      Topic.subscribe(Topic.LayerVisibilityChanged, params => {
        //console.log("refresh")
        this.setState({
          shareUrl: shareUtil.generateShareUrl(this.props.item)
        })
      }),
      Topic.subscribe(Topic.RenderBookingList, () => {
        this.queryUserReservations();
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  queryUserReservations = async () => {
    const { item } = this.props;
    const units = Context.instance.aiim.datasets.units;
    const reservations = Context.instance.aiim.datasets.reservations;
    const source = item.sourceKey;
    if (!item || !reservations || !units || source !== units.getSource().key) {
      return;
    }

    const user = Context.instance.user;
    const username = user.getUsername();
    const unit = item.getFeature();
    const unitId = aiimUtil.getAttributeValue(unit.attributes, FieldNames.UNIT_ID);

    if (!username || !unitId) {
      return;
    }

    const now = getZulu(new Date());
    const whereClauses = [
      `${reservations.unitIdField} = '${unitId}'`,
      `${reservations.reservedForUsernameField} = '${username}'`,
      `${reservations.endTimeField} > TIMESTAMP '${escSqlQuote(now)}'`,
      `${reservations.stateField} IN (1,4)`
    ];
    const where = `${whereClauses.join(' AND ')}`;

    try {
      const myReservations = await reservations.query(where);
      const bookings = (myReservations && myReservations.features) || [];
      const filteredBookings = await this.filterHotelReservations(bookings);
      this.setState({ bookings: filteredBookings });
    } catch (e) {
      console.error(e);
    }
  }

  filterHotelReservations = async (bookings) => {
    if (!bookings || !bookings.length) {
      return [];
    }
    
    const unitsDataset = Context.getInstance().aiim.datasets.units;
    const unitFields = unitsDataset.layer2D && unitsDataset.layer2D.fields;
    const hotelBookings = [];

    // Gather the unit IDs from the reservations to make a query
    const unitIds = bookings
      .map((booking) => {
        const bookingAttrs = booking.attributes;
        const unitId = aiimUtil.getAttributeValue(bookingAttrs, FieldNames.UNIT_ID);
        return `'${escSqlQuote(unitId)}'`;
      });
    // To make sure we don't add duplicate ids to the query
    // Ex: UNIT_ID IN ('1', '1', '2', '2') -> UNIT_ID IN ('1', '2')
    const uniqueIds = [...new Set(unitIds)];

    const assignmentTypeField = aiimUtil.findFieldName(unitFields, FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
    const whereClauses = [
      `${unitsDataset.uidField} IN (${uniqueIds.join(", ")})`,
      `${assignmentTypeField} = 'hotel'`
    ];
    const where = `${whereClauses.join(" AND ")}`;

    try {
      const results = await unitsDataset.query(where);
      const units = (results && results.features) || [];

      // Filter units by those that are hotels
      const hotelingUnitIds = units.map((unit) => aiimUtil.getAttributeValue(unit.attributes, FieldNames.UNIT_ID));

      // Find the bookings that have hoteling unit IDs
      bookings.forEach((booking) => {
        const bookingAttrs = booking.attributes;
        const unitId = aiimUtil.getAttributeValue(bookingAttrs, FieldNames.UNIT_ID);
        if (hotelingUnitIds.includes(unitId)) {
          const unit = units.find((unit) => aiimUtil.getAttributeValue(unit.attributes, FieldNames.UNIT_ID) === unitId);
          hotelBookings.push({ booking, unit });
        }
      });
    } catch(e) {
      console.error(e);
    }

    return hotelBookings;
  }

  confirmBooking = (checkInDate, checkOutDate, allDay) => {
    const type = getBookingSystemType();
    const i18n = Context.getInstance().i18n;
    const options = {
      title: i18n.more.bookWorkspace.multipleBookingTitle,
      message: i18n.more.bookWorkspace.multipleBookingsMessage,
      showOKCancel: true,
      hideCancel: true,
      okLabel: i18n.general.ok
    }
    switch (type) {
      case "office365":
        this.confirmBookingOffice365(checkInDate, checkOutDate);
        break;
      case "esri":
        bookWorkspaceUtil.verifyMultipleBookings(checkInDate, checkOutDate)
        .then((response)=> {
          if(response === "hasExistingBookings") {
            ModalController.confirm(options).then((result)=> {
              if(result && result.ok) this.bookClicked();
            })
          } else {
            this.confirmBookingEsri(checkInDate, checkOutDate, allDay);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error && isNetworkError(error.message)) {
            this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
          }
        })
        break;
      default:
        return;
    }
  }

  confirmBookingOffice365 = (checkInDate, checkOutDate) => {
    // return login(this.bookingSystem)
    // .then((status)=> {
    //   if(status === "Success") return getAccessToken(this.bookingSystem);
    // })
    return getAccessToken(this.bookingSystem).then((token) =>{
      const scheduleEmail = this.state.scheduleEmail;
      const unitName = this.state.unitName;
      const params = {
        email: scheduleEmail,
        unitName,
        checkInDate,
        checkOutDate,
        item: this.props.item
      }
      return bookWorkspace(this.bookingSystem, token, params);
    })
    .then((response) => {
      if(response){
        this.renderBookingConfirmed();
      }
    })
    .catch((error) =>{
      if (error && isNetworkError(error.message)) {
        this.showServerErrorPopup(checkInDate, checkOutDate);
      }
      console.error(error);
    })
  }

  confirmBookingEsri = (checkInDate, checkOutDate, allDay) => {
    const params = {
      unit: this.getFeature(),
      checkIn: checkInDate,
      checkOut: checkOutDate,
      allDay,
      item: this.props.item
    };
    return bookWorkspace(this.bookingSystem, null, params)
      .then((data) => {
        Topic.publish(Topic.RenderBookingList, {});
        this.renderBookingConfirmed(data, params.unit);
      })
      .catch((e) => {
        if (e && isNetworkError(e.message)) {
          this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
        } else {
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel: true
          });
        }
        console.error(e);
      });
  }

  checkAvailability = (checkInDate, checkOutDate, allDay) => {
    const type = getBookingSystemType();
    switch (type) {
      case "office365":
        this.checkAvailabilityOffice365(checkInDate, checkOutDate);
        break;
      case "esri":
        this.checkAvailabilityEsri(checkInDate, checkOutDate, allDay);
        break;
      default:
        return;
    }
  }

  checkAvailabilityOffice365 = (checkInDate, checkOutDate) => {
    // return login(this.bookingSystem)
    // .then((status)=> {
    //   if(status === "Success") return getAccessToken(this.bookingSystem);
    // })
    return getAccessToken(this.bookingSystem).then((token) =>{
      const scheduleEmail = this.state.scheduleEmail;
      const params = {
        schedules : [scheduleEmail],
        startTime : {
          dateTime : checkInDate,
          timeZone: "UTC"
        },
        endTime : {
          dateTime : checkOutDate,
          timeZone: "UTC"
        }
      }
      return getBookingSchedule(this.bookingSystem, token, params);
    })
    .then((availability)=> {
      if(availability && availability.value){
        const scheduleItemsLength = availability.value[0].scheduleItems.length;
        if(scheduleItemsLength === 0){
          this.confirmBooking(checkInDate, checkOutDate);
        }else{
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel:true
          });
        }
      }
    })
    .catch((error)=> {
      if (error && isNetworkError(error.message)) {
        this.showServerErrorPopup(checkInDate, checkOutDate);
      } else {
        const i18n = Context.getInstance().i18n;
        let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
        let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
        errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
        ModalController.confirm({
          isError: true,
          title: title,
          message: errorMessage,
          submessage: null,
          hideCancel:true
        });
      }
      console.error(error);
    })
  }

  getUnitUnavailableMessage =(checkInDate, checkOutDate, allDay)=> {
    const i18n = Context.instance.i18n;
    const lib = Context.instance.lib;
    
    const today = lib.dojo.locale.format(new Date(), { selector:"date", formatLength: "short" });
    const startDate = lib.dojo.locale.format(checkInDate, { selector: "date", formatLength: "short" });
    let endDate = lib.dojo.locale.format(checkOutDate, { selector: "date", formatLength: "short" });

    const locale = Context.instance.lib.dojo.kernel.locale
    const format = (locale === "en" || locale === "en-us") ? "h:mm A" : "H:mm";

    const startTime = lib.dojo.locale.format(checkInDate, { selector: "time", format: format });
    const endTime = lib.dojo.locale.format(checkOutDate, { selector: "time", format: format});

    let msg;
    if (allDay) {
      let dur, day
      endDate = moment(checkOutDate).subtract(1, 'm').toDate();
      endDate = lib.dojo.locale.format(endDate, { selector: "date", formatLength: "short" });

      if (startDate === today && endDate === today) {
        // Available today all day
        dur = ""
        day = i18n.more.bookWorkspace.today
      } else if (startDate === endDate) {
        // Ex: Available on 7/22/21 all day
        dur = i18n.more.bookWorkspace.on
        day = startDate
      } else {
        // Ex: Available from 7/22/21 - 7/23/21 all day
        dur = i18n.more.bookWorkspace.from
        day = startDate + " - " + endDate
      }
      const template = i18n.more.bookWorkspace.noAvailableUnitsAllDay;
      msg = stringFormatter(template, { duration: dur, day });
    } 
    else {
      let dur;
      let dateString = null;
      if (startDate === endDate) {
        if (startDate === today) {
          // Ex: Available today, 5:00 PM to 6:00 PM
          dateString = i18n.more.bookWorkspace.today;
          dur = "";
        } else {
          // Ex: Available on 7/23/21, 5:00 PM to 6:00 PM
          dateString = startDate
          dur = i18n.more.bookWorkspace.on
        }
      } else {
          // Ex: Available from 7/22/21, 5:00 PM to 7/23/21, 6:00 PM
          dur = i18n.more.bookWorkspace.from
      }

      const template = dateString
        ? i18n.more.bookWorkspace.noAvailableUnitsSameDay
        : i18n.more.bookWorkspace.noAvailableUnits

      msg = stringFormatter(template, {
        duration: dur,
        date: dateString,
        startDate,
        startTime,
        endDate,
        endTime
      });
    }
    return msg;
  }

  checkAvailabilityEsri = (checkInDate, checkOutDate, allDay) => {
    const unit = this.getFeature();
    const attributes = getAttributes(unit);
    const unitId = aiimUtil.getAttributeValue(attributes, FieldNames.UNIT_ID);
    const params = { checkInDate, checkOutDate, unitId };
    
    return getBookingSchedule(this.bookingSystem, null, params)
      .then((availableUnits) => {
        if (availableUnits.length === 1 && availableUnits[0] === unitId) {
          this.confirmBooking(checkInDate, checkOutDate, allDay);
        } else {
          let errorMessage = this.getUnitUnavailableMessage(checkInDate, checkOutDate, allDay);
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          //let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel: true
          });
        }
      })
      .catch((error) => {
        if (error && isNetworkError(error.message)) {
          this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
        } else {
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel:true
          });
        }
        console.error(error);
      });
  }

  generateAppLaunchUrls() {
    appLaunchUtil.generateUrlsCategoriesAndLayers(this.props.item).then(urls => {
      this.setState({
        appLaunchUrls: urls
      });
    }).catch(ex => {
       console.error("Error generating app launch urls",ex);
    });
    // appLaunchUtil.generateUrls(this.props.item).then(urls => {
    //   //console.log("urls222",urls);
    //   this.setState(state => {
    //     return {
    //       appLaunchUrls: urls
    //     };
    //   });
    // }).catch(ex => {
    //    console.error("Error generating app launch urls",ex);
    // });
  }

  generate311Url() {
    actionUtil.generate311Url(this.props.item).then(url => {
      this.setState(state => {
        return {
          _311Url: url
        };
      });
    }).catch(ex => {
       console.error("Error generating 311 URL",ex);
    });
  }

  getCaption() {
    const v = this.props.item.getTitle();
    if (typeof v === "string") return v;
    return "";
  }

  getFeature() {
    return (this.props.item.getFeature());
  }

  getSource() {
    return (this.props.item.getSource());
  }

  modeClicked(mode) {
    // const activeModeKey = this.props.infoPanelKey + "-ItemDetails-ActiveMode";
    // if (mode) {
    //   Rdx.setValue(this,activeModeKey,mode);
    // }
    this.setState(state => {
      return {
        mode: mode
      };
    });
    if (this.props.realTimeToggled) this.props.realTimeToggled(mode);
  }

  render() {
      return (
        <div className={CSS.main}>
          {this.renderHeader()}
          {this.renderContent()}
        </div>
      );
  }

  renderActions() {
    const isKiosk = Context.getInstance().isKiosk;
    const item = this.props.item;
    const appLaunchUrls = this.state.appLaunchUrls;
    const hasAppLaunch = (appLaunchUrls && appLaunchUrls.length > 0);
    const listItems = [];

    const source = this.getSource();
    const feature = this.getFeature();
    const hasGeometry = itemUtil.hasGeometry(source,feature);

    let units = Context.instance.aiim.datasets.units;
    const meetingRoomsEnabled = !isKiosk && units && reservationUtil.supportsMeetingRooms();
    let showBookMeetingRoom =  meetingRoomsEnabled && units.isMeetingRoom(source,feature);
    let showBookHotelRoom = !isKiosk && !!this.isBookableUnit();

    let moreActions = {};

    if (item && item.isValid()) {

      if (showBookHotelRoom) {
        listItems.push(
          <li key="bookhotel">
            <Actions.BookHotelRoom item={item}
              onBookClicked={info => {
                this.bookClicked()
              }}
            />
          </li>
        );
        if (hasAppLaunch) {
          moreActions.setHome = true;
        }
      }

      if (showBookMeetingRoom) {
        listItems.push(
          <li key="bookmeeting"><Actions.BookMeetingRoom item={item}/></li>
        );
        if (hasAppLaunch) {
          moreActions.setHome = true;
        }
      }

      if (Context.getInstance().config.networkServiceUrl) {
        listItems.push(
          <li key="directions"><Actions.Directions item={item} disabled={!hasGeometry}/></li>
        );
      }

      if (!isKiosk) {

        if (!moreActions.setHome) {
          listItems.push(
            <li key="setHome"><Actions.SetHome item={item} disabled={!hasGeometry}/></li>
          );
        }

        listItems.push(
          <li key="saveFavorite"><Actions.SaveFavorite item={item} disabled={!hasGeometry}/></li>
        );

        if (this.state.shareUrl) {
          listItems.push(
            <li key="share"><ShareDropdown shareUrl={this.state.shareUrl} caption={this.getCaption()}/></li>
          );
        }

        if (hasAppLaunch) {
          listItems.push(
            <li key="appLaunch">
              <Actions.AppLaunch urls={appLaunchUrls}
                item={item}
                hasGeometry={hasGeometry}
                moreActions={moreActions} />
            </li>
          );
        }

        // const configuration = Context.instance.configuration;
        // const configurables = configuration.extractConfigurables();
        // if (configurables.officeHoteling && configurables.officeHoteling.enabled){
        //   if (this.isBookableUnit()){
        //     const i18n = Context.getInstance().i18n;
        //     bookUnit = (
        //       <BookButtonDiv>
        //         <BookButton
        //           tabIndex="0"
        //           role="button"
        //           aria-label={i18n.more.bookWorkspace.bookInfoAriaLabel}
        //           iconPosition={"before"}
        //           clear
        //           icon={<LabelIcon/>}
        //           onClick={this.bookClicked}
        //         >
        //           {i18n.more.bookWorkspace.bookButton}
        //         </BookButton>
        //       </BookButtonDiv>
        //     )
        //   }
        // }

      }
    }

    if (listItems.length === 0) return null;
    return (
      <div className={CSS.actionBarContainer}>
      <ul className={CSS.actionBar}>
        {listItems}
      </ul>
      {/*}
      <div className={CSS.infopanelBookButton}>
      {bookUnit}
      </div>
      */}
      </div>
    );
  }

  renderBookingConfirmed(data, unit) {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <BookingConfirmed
        unitName = {this.state.unitName}
        levelName = {this.state.levelName}
        facilityName = {this.state.facilityName}
        closePopup = {onClose}
        data={data}
        unit={unit}
      />
    ), node);
  }

  renderBookingDetails(when){
    const node = document.createElement("div");
    document.body.appendChild(node);
    const spaceType = this.state.spaceType;
    const areaName = this.state.areaName;

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <Provider store={Rdx.store}>
        <BookingDetails
          spaceType = {spaceType} areaName = {areaName}
          scheduleEmail = {this.state.scheduleEmail}
          unitName = {this.state.unitName}
          levelName = {this.state.levelName}
          facilityName = {this.state.facilityName}
          checkAvailability = {this.checkAvailability}
          isBookWorkspacePanel = {this.props.isBookWorkspacePanel}
          closePopup = {onClose}
          unitFeature={this.getFeature()}
          when={when}
        />
      </Provider>
    ), node);
  }

  renderContent() {
    const i18n = Context.getInstance().i18n;
    //const isKiosk = Context.getInstance().uiMode.isKiosk;
    const isAnonymous = Context.getInstance().user.isAnonymous();
    const feature = this.getFeature();
    //if (!feature || !feature.geometry) {
    if (!feature) {
      return (
        <div className="i-padded">
          <p>{i18n.infoPanel.messages.noGeometry}</p>
        </div>
      );
    }
    const source = this.getSource();
    const item = this.props.item;
    const itemIsValid = (source && item && item.isValid());
    const hasGeometry = itemUtil.hasGeometry(source,feature);

    let canObserve = false, realTime = null;
    const detailsStyle = {};
    //const activeMode = this.props.rdxActiveMode || "details";
    const activeMode = this.state.mode || "details";
    //if (!isKiosk && !isAnonymous && itemIsValid && source.isAiimPeople()) {
    if (!isAnonymous && itemIsValid && source && source.isPeopleLayer()) {
      const trackingViews =  Context.getInstance().user.trackingViews;
      if (trackingViews) {
        canObserve = trackingViews.canObserve(source,feature);
        if (canObserve) {
          if (activeMode === "realtime") detailsStyle.display = "none";
          realTime = (
            <RealTimeLocation infoPanelKey={this.props.infoPanelKey} item={item}
              realTimePinActive={this.props.realTimePinActive}
              modeClicked={this.modeClicked} />
          );
        }
      }
    }

    const hasBookings = this.state.bookings.length > 0;
    let activeTab = this.props.rdxActiveTab || "attributes";
    if (!hasBookings && activeTab === "mybookings") {
      activeTab = "attributes";
    }
    const tabs = (
      <>
      {/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */}
      <nav className={CSS.tabs} role="tablist">
        {this.renderTab(activeTab,"attributes",i18n.infoPanel.tabs.attributes)}
        {hasBookings ? this.renderTab(activeTab, "mybookings", i18n.infoPanel.tabs.myBookings) : null}
        {this.renderTab(activeTab,"related",i18n.infoPanel.tabs.related,!hasGeometry)}
      </nav>
      </>
    );

    let bookUnit;
    const attributes = item.searchResult.feature.attributes;
    const scheduleEmail = aiimUtil.getAttributeValue(attributes,FieldNames.SCHEDULE_EMAIL);
    const assignmentType = aiimUtil.getAttributeValue(attributes, FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);

    // if(scheduleEmail && assignmentType === "hotel"){
    //   bookUnit = (
    //     <BookButtonDiv>
    //       <BookButton iconPosition={"after"} clear icon={<LabelIcon/>}
    //           onClick={()=>this.bookClicked(item, scheduleEmail)}>
    //         Book
    //       </BookButton>
    //     </BookButtonDiv>
    //   )
    // }

    let tabContent = null;
    if (itemIsValid) {
      tabContent = (
        <div key="i-feature-tabcontent" className={CSS.tabContent}>
          <Attributes item={item} active={activeTab === "attributes"}/>
          <MyHotelBookings bookings={this.state.bookings} active={activeTab === "mybookings"} />
          <Related item={item} active={activeTab === "related"}/>
        </div>
      );
    }

    return (
      <div key="i-infopanel-content" className={CSS.infopanelContent}>
        {realTime}
        <div key="i-feature-content" className={CSS.featureContent} style={detailsStyle}>
          {this.renderActions()}
          {/* {bookUnit} */}
          {tabs}
          {this.props.backNextButtons}
          {tabContent}
        </div>
      </div>
    );
  }

  renderHeader() {
    const caption = this.getCaption();
    return <InfoPanelHeader caption={caption} infoPanelKey={this.props.infoPanelKey}/>
  }

  renderTab(activeTab,type,label,disabled) {
    let className = CSS.tab;
    const hasBookings = this.state.bookings.length;
    const selected = (activeTab === type);
    if (selected) className += " " + CSS.activeTab;
    if (disabled) className += " i--disabled";
    if (hasBookings) className += " i--hasbookings";
    const tab = (
      <button className={className} role="tab" aria-selected={selected}
      onClick={this.tabClicked} data-tabtype={type}><span data-tabtype={type}>{label}</span></button>
    )
    return tab;
  }

  showServerErrorPopup = (checkInDate, checkOutDate, allDay) => {
    const i18n = Context.getInstance().i18n;
    const options = {
      title: i18n.more.bookWorkspace.error,
      message: "Unable to book the hotel. Check your network connection and try again.",
      okLabel: i18n.more.bookWorkspace.tryAgain,
      showOkCancel: true,
      hideCancel : false,
      closeOnOK: true,
      cancelLabel: i18n.more.bookWorkspace.cancel
    };
    ModalController.confirm(options)
    .then(result => {
      if(result.ok) {
        this.confirmBooking(checkInDate, checkOutDate, allDay);
      }
    })
    .catch((error) => {
      if (error && isNetworkError(error.message)) {
        this.showServerErrorPopup(checkInDate, checkOutDate, allDay);
      } else {
        Topic.publish(Topic.publishErrorUpdatingData());
      }
      console.error(error);
    })
  }

  tabClicked(event) {
    try {
      const activeTabKey = this.props.infoPanelKey + "-ItemDetails-ActiveTab";
      const type = event.target.getAttribute("data-tabtype");
      if (type) {
        Rdx.setValue(this,activeTabKey,type);
      }
    } catch(ex) {
      console.warn("Error handling tab click for event:",event);
      console.error(ex);
    }
  }

  isBookableUnit = () => {
    const unitFeature = this.getFeature();
    const attributes = unitFeature.attributes;
    const assignmentType = aiimUtil.getAttributeValue(attributes, FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
    const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID);
    if (assignmentType !== "hotel" || !areaId) {
      return false;
    }

    if (Context.instance.aiim.useRestrictedHotelBookings()) {
      let ids = Context.instance.aiim.getAppUserAreaIDs();
      if (ids.indexOf(areaId) === -1) {
        return false;
      }
    }

    const bookingSystemType = getBookingSystemType();
    switch (bookingSystemType) {
      case "office365":
        const scheduleEmail = aiimUtil.getAttributeValue(attributes, FieldNames.SCHEDULE_EMAIL);
        return !!scheduleEmail;
      case "esri":
        // const reservationMethod = aiimUtil.getAttributeValue(attributes, FieldNames.RESERVATION_METHOD);
        // return !!reservationMethod;
        return true;
      default:
        return false;
    }
  }
}

const mapStateToProps = (state,ownProps) => {
  //const activeModeKey = ownProps.infoPanelKey + "-ItemDetails-ActiveMode";
  const activeTabKey = ownProps.infoPanelKey + "-ItemDetails-ActiveTab";
  return {
    //rdxActiveMode: Rdx.getValue(state,activeModeKey),
    rdxActiveTab: Rdx.getValue(state,activeTabKey)
  }
}

export default connect(mapStateToProps)(ItemDetails);